import React from "react";
import { Route, Routes } from "react-router-dom";
import PoRequest from "../pages/jobs/InvoiceToPdf";
import Search from "../pages/search/index";
import ContractsView from "../pages/jobs/ContractsView";

export default function SearchRoute() {
  return (
    <Routes>
      <Route path="" element={<Search />} />
      <Route path="/invoiceToPdf" element={<PoRequest />} />
      <Route
        path="/contracts/view/:organization_id/contract/:contract"
        element={<ContractsView />}
      />
    </Routes>
  );
}
